module.exports = __webpack_public_path__ + "media/rocket-league-recap_highlight.82cdea01.mp4";